// post-t7-2b remate (R2, 5.3): EL 429 DEL FRENO EN EL IDIOMA DEL USUARIO.
//
// El freno del servidor (`check_rate_limit_or_raise`) contesta 429 con un `detail` de TEXTO en
// ingles y SIN `error_code` ("Too many requests. Try again in N seconds." o "Rate limit
// exceeded. Maximum N requests per M seconds."; el interceptor solo le traduce los segundos).
// Las pantallas del registro lo pintaban tal cual. Esta pieza da la frase generica traducida
// (`common:errors.rate_limit_generic`) para ESE caso y `null` para todo lo demas, asi cada
// pantalla conserva su aviso de hoy:
//   - un 429 con `detail` que no es texto (o vacio) sigue como hoy;
//   - un 429 que trae su propio `error_code` (los de "demasiados intentos" de la verificacion)
//     ya llega traducido con su sentido, y sigue como hoy;
//   - cualquier otro estado (un 400 con su texto) sigue como hoy.
// No importa el cliente de la API: solo lee el error que la pantalla ya tiene en la mano.

export function esElFrenoConTexto(err) {
  const respuesta = err && err.response;
  if (!respuesta || respuesta.status !== 429) return false;
  const cuerpo = respuesta.data || {};
  if (cuerpo.error_code) return false;
  return typeof cuerpo.detail === 'string' && cuerpo.detail.length > 0;
}

export function avisoDelFreno(err, t) {
  return esElFrenoConTexto(err) ? t('common:errors.rate_limit_generic') : null;
}
